<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-8/12 px-4">
      <CardSettings />
    </div>
    <div class="w-full lg:w-4/12 px-4">
      <CardProfile />
    </div>
  </div>
</template>
<script>
/* 
  Class: Dashboard
  Description: This class representing a main entry point for dashboard.
*/

/* Imports */
import CardSettings from "@/components/Cards/User/CardSettings.vue";
import CardProfile from "@/components/Cards/User/CardProfile.vue";
/* /Imports/ */

export default {
  /* 
    Define different meta options. 
  */
  metaInfo() {
    return {
      title: this.$appName,
      titleTemplate: '%s | ' + this.$route.name
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    CardSettings,
    CardProfile
  },
};
</script>